<template>
  <div class="px-standard">
    <div
      :class="innerWrapperClass"
      class="border-t border-neutral-200 py-6 lg:py-10"
    >
      <h3
        v-if="title || $slots.title"
        class="text-2xl font-title text-neutral-900 font-medium lg:font-bold"
      >
        <template v-if="$slots.title">
          <slot name="title" />
        </template>
        <template v-else>
          {{ title }}
        </template>
      </h3>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterPartnerDetailCard',

  props: {
    innerWrapperClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
